function isFrame() {
    try {
        return window.self !== window.top
    } catch (e) { // eslint-disable-line local-rules/no-error-swallowing
        return true
    }
}

export default isFrame()
